import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  fill?: string;
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChevronRightIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChevronRightIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.43415 4.00001C8.65629 4.00001 8.87844 4.0848 9.04801 4.25438L16.1798 11.3861C16.5189 11.7253 16.5189 12.2747 16.1798 12.6139L9.04801 19.7456C8.70886 20.0848 8.15943 20.0848 7.82028 19.7456C7.48113 19.4065 7.48113 18.8571 7.82028 18.5179L14.3382 12L7.82028 5.4821C7.48113 5.14294 7.48113 4.59352 7.82028 4.25437C7.98985 4.0848 8.21201 4.00001 8.43415 4.00001Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ChevronRightIcon;
